module.exports = __webpack_public_path__ + "static/img/CEE1.eba4d124.jpg";